var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticStyle:{"margin-bottom":"15px"}},[_c('b',[_vm._v(_vm._s(_vm.text))]),_c('br'),(_vm.link_out)?_c('a',{attrs:{"href":_vm.value,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }